import { Cell } from 'react-table';

import { CellText } from 'coreOld/elements';
import { AlignText } from 'coreOld/enums';

export const columns = [
  {
    Header: 'Base UOM',
    accessor: 'fromUom',
  },
  {
    Header: 'Alternate UOM',
    accessor: 'toUom',
  },
  {
    Header: () => <CellText mainText="Multiplier" alignText={AlignText.RIGHT} />,
    accessor: 'multiplier',
    Cell: ({ row }: Cell<any>) => (
      <CellText mainText={parseFloat(row.original.multiplier)} alignText={AlignText.RIGHT} />
    ),
  },
];
